    //converts integer(seconds) into the duration
    export function secondsToDuration(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return hrs > 0 ? `${hrs}:${mins}:${secs}` : `${mins}:${secs}`;
    }

    // //gets the date only from timestamp - DD:MM:YYYY
    // export function formatDate(isoString) {
    //     const date = new Date(isoString);
    //     const day = date.getDate().toString().padStart(2, '0');
    //     const month = (date.getMonth() + 1).toString().padStart(2, '0'); // months are 0-based
    //     const year = date.getFullYear();
    //     return `${day}/${month}/${year}`;
    // }



    export function formatDate(isoString) {
        const hindiMonths = [
          'जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून',
          'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर'
        ];
      
        const date = new Date(isoString);
        const day = date.getDate().toString().padStart(2, '0');
        const monthName = hindiMonths[date.getMonth()];
        const year = date.getFullYear();
      
        return `${day} ${monthName} ${year}`;
      }
      